import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type RemoveImportMethodParams = {
  importId: string;
};

export default function useDeleteImportMethod(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);
  const mutation = $api.useMutation("delete", "/shops/{shopId}/imports/{importId}");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async ({ importId }: RemoveImportMethodParams) => {
      return mutation.mutateAsync({
        params: { path: { importId, shopId: shop.id } },
      });
    },
  });
}
